import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-white py-3 md:py-4 px-3 relative overflow-hidden border-b-4 border-[#FF6B00]" data-id="element-52">
      <div className="max-w-3xl mx-auto text-center relative z-10 flex flex-col items-center" data-id="element-53">
        <h1 className="text-3xl md:text-5xl font-black text-[#0B1F3A] leading-tight mb-2 uppercase tracking-tight" data-id="element-54">
          Todo tu año de funcional <span className="text-[#FF6B00]" data-id="element-55">listo</span>
        </h1>

        <div className="my-2 cursor-pointer transform hover:scale-[1.02] transition-transform duration-300 w-full max-w-lg" onClick={scrollToPricing} data-id="element-56">
          <img src="https://cdn.magicpatterns.com/uploads/fgVmqHnMiLnFY2QmSeawdH/mockups_FUNCIONAL_.png" alt="Kit Completo Funcional Listo" className="w-full h-auto drop-shadow-2xl" data-id="element-57" />
        </div>

        <p className="text-gray-700 text-sm md:text-base font-bold mb-1 max-w-xl mx-auto leading-snug" data-id="element-58">
          Clases, circuitos, rutinas y progresiones ya armadas para que dejes de
          improvisar.
        </p>

        <div className="bg-[#FFF4ED] border-2 border-[#FF6B00] rounded-lg px-4 py-2 mb-3 inline-block" data-id="element-59">
          <p className="text-[#FF6B00] font-black text-sm md:text-base" data-id="element-60">
            👉 Llegás al gimnasio sabiendo exactamente qué hacer.
          </p>
        </div>

        <div className="flex justify-center mb-2 w-full max-w-sm" data-id="element-61">
          <CTAButton onClick={scrollToPricing} variant="primary" fullWidth className="py-3 text-sm md:text-base" data-id="element-62">
            SÍ, QUIERO MIS CLASES RESUELTAS
          </CTAButton>
        </div>

        <div className="inline-block bg-[#F5F5F5] border border-gray-300 rounded-full px-3 py-1" data-id="element-63">
          <p className="text-gray-600 text-xs md:text-sm font-bold flex items-center gap-1.5" data-id="element-64">
            <span className="text-[#FF6B00] text-sm" data-id="element-65">★★★★★</span>
            +300 profesores ya usan este sistema
          </p>
        </div>
      </div>
    </section>;
}